import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@styles/scss/theme.scss';
import { loadApp } from '@/vue/app-loader.js';
import './splide.js';

// Document Ready, most of your code should be put in here
$(function () {
	var scheduleModalLoaded = false;
	var locatorModalLoaded = false;

	$('#btnScheduleFooter').on('click', function () {
		$('#scheduleModal').foundation('open');
	});

	$('#scheduleModal').on('open.zf.reveal', function () {
		location.hash = 'service';

		if (scheduleModalLoaded == false) {
			loadApp('schedule');
			scheduleModalLoaded = true;
		}
	});

	$('#locatorModal').on('open.zf.reveal', function () {
		if (locatorModalLoaded == false) {
			loadApp('store-locator');
			locatorModalLoaded = true;
		}
	});

	loadApps();

	jQuery('header').on('click', '.locContainer', function () {
		jQuery('#locatorModal').foundation('open')
	});

	$('.show-locator-modal').on('click', function () {
		jQuery('#locatorModal').foundation('open');
	});
	$('.open-scheduler-from-nav').on('click', function () {
		$('#scheduleModal').foundation('open');
	});
});

$(document).ready(function () {
	if (mem_partnerSlugs) {
		if (globalVue.$store.state.location) {
			if (globalVue.$store.state.location.selectedStore) {
				updateHrefs(globalVue.$store.state.location.selectedStore, 'initial');
			}
		}

		globalVue.$store.watch(
			function (state, getters) {
				return state.location.selectedStore;
			},

			function (selectedStore, oldValue) {
				if (selectedStore) {
					updateHrefs(selectedStore, true);
				}
			}
		);

		function updateHrefs(selectedStore, updating = false) {
			$('a').each(function () {
				let thisHREF = $(this).attr('href');

				// if it's a jump scroll link
				if (thisHREF?.startsWith('#') ) {
					return; // do nothing
				}


				// if url contains http and domain is not the same, skip it
				if ( !thisHREF || thisHREF.indexOf('tel:') != -1 || thisHREF.indexOf('/#') == 0 ||
					thisHREF.indexOf('mailto:') != -1 || thisHREF == '/' ||
					(thisHREF.indexOf('http') != -1 && thisHREF.indexOf(window.location.hostname) == -1)) {
					return;
				}

				let baseURL = window.location.protocol + '//' + window.location.hostname;
				let anchor = '';
				let querystring = '';
				let urlPartner = '';

				// strip baseURL from href
				if (thisHREF.indexOf(baseURL) == 0) {
					thisHREF = thisHREF.replace(baseURL, '');
				}

				// if it's empty or a wordpress link, skip it
				if (!thisHREF || thisHREF.indexOf('wp-') != -1) { return; }


				// if it's a relative link
				if (thisHREF.indexOf('#') != -1) {
					[thisHREF, anchor] = thisHREF.split('#');
				}

				if (thisHREF.indexOf('?') != -1) {
					[thisHREF, querystring] = thisHREF.split('?');
				}

				// nothing but slashed ternsm left
				let urlParts = thisHREF.split('/');
				if (! urlParts[0]) { urlParts.shift(); } // remove empty first element

				// if it's a store link
				if (urlParts[0] == 'store') {
					urlPartner = urlParts[1].toLowerCase() || ''; // domain.com/part0-store/part1-partnerSlug/part2/part3/?querystring#anchor

					// if it's not a partner slug
					if (! mem_partnerSlugs.includes(urlPartner)) { // not found in list
						// replace old or duplicate partner name
						urlParts[1] = selectedStore.slugPartner;
					} else {
						// everythings cool?
					}

					// cleanup other slugs (all but the first two)
					for (let i = 2; i < urlParts.length; i++) {
						if (mem_partnerSlugs.includes(urlParts[i].toLowerCase())) {
							urlParts.splice(i, 1); // remove that element
						}
					}
				} else { // it's not a store link
					if ( urlParts[0] ) { // alternative is "/#anchor" or "/?querystring"
						urlPartner = urlParts[0].toLowerCase(); // domain.com/part0-partnerSlug/part1/part2/part3/?querystring#anchor

						// not found in list, then it's not a branded page, brand it.
						if (!mem_partnerSlugs.includes(urlPartner)) { // not a valid partner slug
							urlParts.unshift(selectedStore.slugPartner); // add partner slug to beginning
						} else { // it is a valid partner slug
							if (urlPartner != selectedStore.slugPartner) {
								urlParts[0] = selectedStore.slugPartner; // replace with proper slug
							}
						}

						// cleanup other slugs (all but the first)
						for (let i = 1; i < urlParts.length; i++) {
							if (mem_partnerSlugs.includes(urlParts[i].toLowerCase())) {
								urlParts.splice(i, 1); // remove that element
							}
						}
					}
				}

				// put it back together
				let newURL = '/' + urlParts.join('/') + (querystring ? '?' + querystring : '') + (anchor ? '#' + anchor : '');

				$(this).attr('href', newURL);
			}); // end a-each function
		} // end function updateHrefs
	} // end if mem partnerslugs
}); // doucment.ready

function loadApps() {
	let appElements = document.getElementsByClassName('vue-app');

	if (appElements.length > 0) {
		for (let app of appElements) {
			if (app.id) {
				loadApp(app.id);
			}
		}
	}
}
